import type { ReactNode } from "react";
import { Icon } from "../Icon";

const ICON_BY_KIND = { ok: "check", fail: "alert", warn: "alert", info: "info" } as const;

export function Notice({ kind, children }: { kind: "info" | "warn" | "fail" | "ok"; children: ReactNode }) {
  return (
    <div className={`notice notice-${kind}`}>
      <Icon name={ICON_BY_KIND[kind]} className="notice-ico" />
      <div className="grow">{children}</div>
    </div>
  );
}
